import React from 'react'
import pharmacist from "../assets/pharmacist.jpg"
import { FaArrowRight, FaCheckCircle } from "react-icons/fa"

const Hero = () => {
  

  const features = [
    "Smart Inventory Management",
    "Automated Prescription Processing",
    "Patient Health Tracking"
  ];

  return (
    <div className="relative overflow-hidden pt-20 pb-16 md:py-28 lg:py-32">
      {/* Background gradient */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-50 to-white z-0"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-40 right-40 w-64 h-64 rounded-full bg-blue-100 opacity-30 blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-32 h-32 rounded-full bg-teal-100 opacity-40 blur-2xl"></div>
      
      <div className="container mx-auto px-5 relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Content Column */}
          <div className="space-y-6 md:pr-8">
            {/* Badge */}
            <div className="inline-flex items-center py-2 px-4 bg-white border border-blue-100 rounded-full shadow-sm">
              <div className="h-2 w-2 rounded-full bg-blue-500 mr-2"></div>
              <p className="text-sm font-medium text-gray-600">Next-Gen Pharmacy Management</p>
            </div>
            
            {/* Heading */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight text-gray-800">
              Transform Your Pharmacy with <br/>
              <span className="text-blue-600 italic relative">
                RxUltimate
                <span className="absolute -bottom-2 left-0 h-1 w-full bg-blue-400 opacity-50 rounded-full"></span>
              </span>
            </h1>
            
            {/* Description */}
            <p className="text-lg text-gray-600 leading-relaxed max-w-lg">
              Experience a powerful, innovative, and sustainable pharmacy management system designed to empower healthcare professionals, improve patient outcomes, and reduce administrative burdens.
            </p>
            
            {/* Features list */}
            <div className="space-y-3">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center">
                  <FaCheckCircle className="text-green-500 mr-2" />
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
            
            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 mt-8">
              <a href="#join-us">
                <button className="flex items-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                  Get Started
                  <FaArrowRight className="ml-2" />
                </button>
              </a>
              <a href="#demo" className="inline-flex items-center px-6 py-4 bg-white hover:bg-gray-50 text-blue-600 font-medium rounded-lg border border-blue-100 shadow-sm hover:shadow-md transition-all duration-300">
                Watch Demo
              </a>
            </div>
            
            {/* Trust indicators */}
            <div className="pt-6">
              <p className="text-sm text-gray-500 mb-2">Trusted by healthcare professionals:</p>
              <div className="flex space-x-6">
                <div className="w-16 h-6 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-16 h-6 bg-gray-200 rounded animate-pulse"></div>
                <div className="w-16 h-6 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>
          
          {/* Image Column */}
          <div className="relative">
            {/* Main image with effects */}
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent z-10"></div>
              <img 
                src={pharmacist} 
                alt="Pharmacist using RxUltimate" 
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 border-8 border-blue-100 rounded-2xl z-0"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border-8 border-teal-100 rounded-2xl z-0"></div>
            
            {/* Stats card */}
            <div className="absolute -bottom-5 -left-5 md:bottom-8 md:left-8 bg-white p-4 rounded-xl shadow-xl z-20 max-w-xs">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                  <span className="text-green-500 text-lg font-bold">↑</span>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-800">98.7%</p>
                  <p className="text-sm text-gray-500">Prescription Accuracy</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero